import React, { useState } from 'react';
import { Flex } from '@rebass/grid';
import { isEmpty } from 'lodash';

const ForwardAFriendConfirmation = ({ emailIds }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <Flex display="flex" justifyContent="center" flexDirection="column">
      <Flex display="flex" mb="20px" justifyContent="center" mt="90px">
        <img
          alt=""
          src="/assets/images/email-sent.svg"
          onLoad={() => setImgLoaded(true)}
        />
      </Flex>
      {imgLoaded && (
        <Flex
          display="flex"
          justifyContent="center"
          padding={window.innerWidth < 600 ? "5px 20px" : "5px 5px"}
          style={{ color: '#000000', fontSize: '16px' }}
        >
          Your article was successfully shared with{' '}
          {isEmpty(emailIds) ? 0 : emailIds.split(',').length} members
        </Flex>
      )}
    </Flex>
  );
};

export default ForwardAFriendConfirmation;
